import { v1 as uuid } from 'uuid';

import * as Storage from './localStorage';

declare global {
  interface Window {
    storageInitialized: boolean;
  }
}

const isBrowser = typeof window !== 'undefined' || typeof document !== 'undefined';

if (isBrowser && !window.storageInitialized) {
  Storage.initialize();
  window.storageInitialized = true;
}

export const getOrCreate = async (): Promise<any> => {
  const keys: string[] = await Storage.keys();

  if (keys.length) {
    return await Storage.getItem(keys[0]);
  }

  const id = uuid();

  return await Storage.setItem(id, { uuid: id, created: new Date() });
};

export const update = async (data: any): Promise<any> => {
  const local = await getOrCreate();

  return await Storage.setItem(local.uuid, {
    ...local,
    data: { ...local.data, ...data },
  });
};

export const destroy = async (): Promise<any> => {
  return await Storage.clear();
};
